module.exports = __webpack_public_path__ + "img/a6f8d6d.jpg";